import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import { MessageService } from "primeng/api";
@Component({
  selector: "app-homepage",
  templateUrl: "./homepage.component.html",
  styleUrls: ["./homepage.component.css"],
})
export class HomepageComponent implements OnInit {
  news: any = [];
  BannerNews: any = [];
  bannerImages: any = [];
  awards: any = [];
  gallery: any = [];
  archers: any = [];
  ArcherData: any = [];
  Circulars: any;
  Forms: any;
  Elections: any;
  FilterPhoto: any;
  ArjunAwards: any;
  DronaAwards: any;
  DhyanChand: any;
  PadmaShree: any;
  quickLinks: any;
  videoArray:any=[];

  days: any;
  hours: any;
  minutes: any;
  seconds: any;
  tabsData: any;

  eventsData:any=[]
  instaPost:any

  displayModal: boolean;

  constructor(
    private router: Router,
    public global: GlobalService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) {
    // this.tabsData = [
    //   {
    //     type: "Circular",
    //     data: [
    //       {
    //         date: "09 sept 2021",
    //         title:
    //           " a litle description of the event, before you make me this way, you a litle description of the event, before you make me this way, youa litle description of the event, before you make me this way, you",
    //       },
    //       {
    //         date: "09 sept 2021",
    //         title:
    //           " a litle description of the event, before you make me this way, you",
    //       },
    //       {
    //         date: "09 sept 2021",
    //         title:
    //           " a litle description of the event, before you make me this way, you",
    //       },
    //     ],
    //   },
    //   {
    //     type: "Tenders",
    //     data: [
    //       {
    //         date: "09 sept 2021",
    //         title:
    //           " a litle description of the event, before you make me this way, you",
    //       },
    //       {
    //         date: "09 sept 2021",
    //         title:
    //           " a litle description of the event, before you make me this way, you",
    //       },
    //       {
    //         date: "09 sept 2021",
    //         title:
    //           " a litle description of the event, before you make me this way, you",
    //       },
    //     ],
    //   },
    //   {
    //     type: "Jobs",
    //     data: [
    //       {
    //         date: "09 sept 2021",
    //         title:
    //           " a litle description of the event, before you make me this way, you",
    //       },
    //       {
    //         date: "09 sept 2021",
    //         title:
    //           " a litle description of the event, before you make me this way, you",
    //       },
    //       {
    //         date: "09 sept 2021",
    //         title:
    //           " a litle description of the event, before you make me this way, you",
    //       },
    //     ],
    //   },
    // ];

    this.archers.length = 5;
 
  }

  ngOnInit(): void {
    this.showModalDialog()
    this.getDetails();
    this.getNews();
    this.getCircular();
    this.getForms();
    this.getElections();
    this.getGallery();
    this.getVideo();
    this.getAwardsArjun();
    this.getAwardsDrona();
    this.getAwardsDhyan();
    this.getAwardsPadma();
    this.getEventList();
    this.getEvents();
    this.getInstaPost();
  }

  showModalDialog() {
    this.displayModal =true;
}

getVideo() {
  const url = this.global.basePath + "common/circularlist?modelType=photo&isVideo=true";
  this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
    const data = res[0].json.circular;
    console.log(
      "🚀 ~ file: gallery.component.ts ~ line 83 ~ GalleryComponent ~ this.global.GetRequestUnauthorised ~ data",
      data
    );
    this.videoArray = data;
  
    // this.FilterPhoto = this.gallery.slice(3);
  });
}

  getDetails() {
    const url = this.global.basePath + "common/archerinfo";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.approved;
      this.ArcherData = data;
    });
  }

  


  getEventList() {
    const url = this.global.basePath + "common/eventlist";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.event;
      this.tabsData = data;
    });
  }

  getNews() {
    const url = this.global.basePath + "news";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.data;
      this.news = data;
      
      console.log("🚀 ~ file: homepage.component.ts ~ line 157 ~ HomepageComponent ~ this.global.GetRequestUnauthorised ~ this.news", this.news)

      if(this.news.length >0){
        this.BannerNews.push(
          this.news[0],
          this.news[1],
          this.news[2],
          this.news[3],
        );
      }
    


      // this.BannerNews = this.news.slice(4);
      console.log("🚀 ~ file: homepage.component.ts ~ line 162 ~ HomepageComponent ~ this.global.GetRequestUnauthorised ~ BannerNews", this.BannerNews)

    });
  }

  getCircular() {
    const url = this.global.basePath + "common/circularlist?modelType=circular&isElection=false";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.Circulars = data;
    });
  }

  getForms() {
    const url = this.global.basePath + "common/circularlist?modelType=form";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.Forms = data;
    });
  }
  getElections() {
    const url =
      this.global.basePath +
      "common/circularlist?modelType=circular&type=AAI%20Election";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.Elections = data;
    });
  }

  getGallery() {
    const url = this.global.basePath + "common/circularlist?modelType=photo";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.gallery = data;
      // this.FilterPhoto = this.gallery.slice(3);
    });
  }

  newsDetails(id: any) {
    this.router.navigateByUrl("news-detail/" + id);
  }
  getAwardsArjun() {
    const url =
      this.global.basePath +
      "common/circularlist?modelType=awardee&awardName=Arjuna Award";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.ArjunAwards = data.reverse();
    });
  }
  getAwardsDrona() {
    const url =
      this.global.basePath +
      "common/circularlist?modelType=awardee&awardName=Dronacharya Award";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.DronaAwards = data.reverse();
    });
  }
  getAwardsDhyan() {
    const url =
      this.global.basePath +
      "common/circularlist?modelType=awardee&awardName=Dhyan Chand Award";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.DhyanChand = data.reverse();
    });
  }
  getAwardsPadma() {
    const url =
      this.global.basePath +
      "common/circularlist?modelType=awardee&awardName=Padmashree Award";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.PadmaShree = data.reverse();
    });
  }

  getTimer(date:any,id:any){
    // Set the date we're counting down to
    var countDownDate = new Date(date).getTime();
    // Update the count down every 1 second
    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();
  
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
  
      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
      document.getElementById(id).innerHTML =
        this.days +
        "d " +
        this.hours +
        "h " +
        this.minutes +
        "m " 
    }, 1000);
    }

  getEvents() {
    const url =
      this.global.basePath +
      "common/circularlist?modelType=event"
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.eventsData = data;

      for(let i=0; i< data.length; i++){
        this.getTimer(data[i].dateTime , data[i]._id)
      }

    });
  }


  getInstaPost() {
    const url =
      this.global.basePath +
      "common/latestpost"
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.data;
      console.log("🚀 ~00000000ccccccc", data)
      this.instaPost = data;

    });
  }


  goToAward(award: any) {
    console.log(
      "🚀 ~ file: homepage.component.ts ~ line 180 ~ HomepageComponent ~ goToAward ~ award",
      award
    );
    this.router.navigateByUrl("award/" + award);
  }

  updatesDetails(id: any) {
    this.router.navigateByUrl("event-detail/" + id);
  }

  fame() {
    this.router.navigateByUrl("fame-hall");
  }
  signup() {
    this.router.navigateByUrl("role-select");
  }
  toArchers() {
    this.router.navigateByUrl("archers");
  }
  executive() {
    this.router.navigateByUrl("executive");
  }
  toGallery() {
    this.router.navigateByUrl("gallery");
  }
  toNews(){
    this.router.navigateByUrl("news");
  }

  toUnit(){
    this.router.navigateByUrl("member-unit");
  }

  

  eventDetails(id: any) {
    this.router.navigateByUrl("event-detail/" + id);
  }
  toRTI() {
    this.router.navigate(["/rti"]);
  }
  toGovermentSanction() {
    this.router.navigate(["/goverment-section"]);
  }
  toSexualHarassment() {
    this.router.navigate(["/sexual-harassment"]);
  }

  
  


}
